import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * *portalTableCell="..." directive is used to provide the html template for a table cell.
 * it can be initialized, among other properties with e.g. "let entry; id: 'column/property-name', data: 'column/property-name';"
 * `let entry` - allows to reference the table-row object/data in the html template.
 * `id` - is the name used in `getColumns()` function of the corresponding component to populate the column with data from entry with the same name property.
 * `data` - on the other case is similar to the `id` in specifying the column on property name, however, the data from that property will also be used for filtering table rows (searching).
 */
@Directive({
  selector: '[portalTableCell]',
  standalone: false,
})
export class TableCellDirective {
  /**
   * specify CSS classes to be applied on the table-cell.
   */
  @Input('portalTableCellClass')
  class = '';

  /**
   * Column/property name referencing data used to render in the cell and also be part of the data filter function.
   */
  @Input('portalTableCellData')
  data = '';

  /**
   * Column/property name referencing data used to render in the cell.
   */
  @Input('portalTableCellId')
  id: string;

  @Input('portalTableCellSortable')
  sortable: boolean = true;

  /**
   * table-cell width that well be applied as a style property to the html-tag.
   */
  @Input('portalTableCellWidth')
  width: string;

  constructor(private template: TemplateRef<any>) {}

  get identifier() {
    return this.id || this.data;
  }
}
